import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=538ffe7e&scoped=true&"
import script from "./lang.vue?vue&type=script&lang=js&"
export * from "./lang.vue?vue&type=script&lang=js&"
import style0 from "./lang.vue?vue&type=style&index=0&id=538ffe7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ffe7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538ffe7e')) {
      api.createRecord('538ffe7e', component.options)
    } else {
      api.reload('538ffe7e', component.options)
    }
    module.hot.accept("./lang.vue?vue&type=template&id=538ffe7e&scoped=true&", function () {
      api.rerender('538ffe7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/lang.vue"
export default component.exports